import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetBuildingClientTagsRequest = {
  buildingId: number | undefined
}

export const getBuildingClientTagsQueryKey = (data: GetBuildingClientTagsRequest) => [
  'useGetBuildingClientTags',
  data,
]

const getBuildingClientTags = async (data: GetBuildingClientTagsRequest): Promise<string[]> => {
  const response = await authAPI.get<string[]>(`/building/${data.buildingId}/client-tags`)
  return response.data
}

export const useGetBuildingClientTags = (data: GetBuildingClientTagsRequest) =>
  useQuery({
    enabled: !!data.buildingId,
    queryFn: () => getBuildingClientTags(data),
    queryKey: getBuildingClientTagsQueryKey(data),
  })
